<h3 class="flex flex-wrap items-center gap-2">
    <ng-container *ngIf="commission$ | async as commission">
        <div class="font-bold text-center">{{ commission.Description }}</div>
        <div class="font-bold text-center">{{ (customer$ | async)?.DisplayName }}, {{ commission.InterneNummer }}, {{ commission.Auftragsnummer }}</div>
    </ng-container>
    <div class="font-bold text-center">{{ (commissionType$ | async)?.Name }}</div>
    <div *ngIf="commissionRouterLink$ | async as link" class="commission-theme theme-override">
        <a app-button Lighter [matTooltip]="cls.getSingle$('Commission') | async" class="wide-button" [routerLink]="link">
            <fa-icon [icon]="CommissionMeta.Icon"></fa-icon>
        </a>
    </div>
</h3>
<div class="flex gap-4 items-center my-4" *ngIf="commissionAddress$ | async as address">
    <a app-round-button matTooltip="Route" target="_blank" [href]="navigationUrl$ | async">
        <fa-icon icon="directions"></fa-icon>
    </a>
    <a class="link" href="" (click)="openMapDialog(address)"><fa-icon icon="map-marker-alt"></fa-icon> {{ addressLabel$ | async }} </a>
</div>
<div class="flex gap-4 flex-wrap p-2">
    <app-commission-scheduler [commissionId]="commissionId$ | async"></app-commission-scheduler>
    <app-detail-commission-event-list
        style="position: relative"
        class="basis-md grow"
        *ngIf="ps.Has$(ps.Permissions.GetServiceHistory) | async"
        [View]="{ order: 0, type: '', expanded: true }"
        [CommissionId]="commissionId$ | async"
    ></app-detail-commission-event-list>
    <app-comment-list
        class="basis-md grow"
        [ViewConfig]="{ order: 0, type: '', expanded: true }"
        [Inline]="false"
        [Expandable]="true"
        [EntityId]="commissionId$ | async"
        [EntityType]="CommentEntityTypeEnum.Commission"
        [FileUploadParams]="commentFileUploadParams$ | async"
    ></app-comment-list>
    <app-involved-persons-list
        class="basis-md grow"
        style="max-height: 30rem; margin-bottom: auto"
        [entityId]="commissionId$ | async"
        [entityType]="Person2EntityEntityTypeEnum.Commission"
        [expanded]="false"
        [complainTypeId]="beteiligtePersonenComplainTypeId$ | async"
        [canAdd]="!((commission$ | async)?.Deleted || !(ps.Has$(ps.Permissions.EditCommission) | async))"
        headline="Projektbeteiligte"
        [headerIcon]="ContactBookMeta.Icon"
        addButtonText="Beteiligte Personen"
    ></app-involved-persons-list>
    <mat-expansion-panel class="basis-md grow commission-card" style="margin-bottom: auto" *ngIf="hasGeneratedDocumentTypesForConstructionDiary$ | async">
        <mat-expansion-panel-header [collapsedHeight]="HeaderHeight">
            <div class="card-header">
<!--                <fa-icon class="icon" icon="triangle-exclamation"></fa-icon>-->
                <h3>
                    Erhebungsblätter<span> ({{ generatedDocumentTypesForConstructionDiaryCountsSum }})</span>
                </h3>
            </div>
        </mat-expansion-panel-header>
        <mat-tab-group>
            <mat-tab *ngFor="let genDocType of generatedDocumentTypesForConstructionDiaryVM$ | async; index as index" [label]="getMatGroupTitle(genDocType.header, generatedDocumentTypesForConstructionDiaryCounts[index])">
                <app-dave-list-card
                    (Count)="updateGeneratedDocumentTypesForConstructionDiaryCountsSumCount(index, $event)"
                    [Headline]="genDocType.header"
                    HeaderIcon="file-signature"
                    [EmptyText]="'Keine ' + genDocType.header +  ' vorhanden'"
                    [Data]="genDocType.generatedDocuments$ | async"
                    [HasSuffixButton]="true"
                    [DisplayedCollums]="['Name']"
                    [Clickable]="true"
                    [IsExpandable]="false"
                    [Expanded]="true"
                    (EntryClicked$)="openDocDialog($event.entry)"
                    style="max-height: 50vh"
                >
                    <app-add-report-button [Inverted]="false" headerButton [openPopup]="true" [PreselectedType]="genDocType.slug" [CustomerId]="(commission$ | async)?.CustomerId" [CommissionId]="(commission$ | async)?.Id"></app-add-report-button>

                </app-dave-list-card>
            </mat-tab>
        </mat-tab-group>
    </mat-expansion-panel>
    <mat-expansion-panel class="basis-md grow commission-card interruption-event-list-card" style="margin-bottom: auto">
        <mat-expansion-panel-header [collapsedHeight]="HeaderHeight">
            <div class="card-header">
                <fa-icon class="icon" icon="triangle-exclamation"></fa-icon>
                <h3>
                    Tickets<span> ({{ interruptionEventsCountSum }})</span>
                </h3>
            </div>
        </mat-expansion-panel-header>
        <mat-tab-group>
            <mat-tab *ngFor="let eventType of interruptionEventTypes$ | async; index as index" [label]="getMatGroupTitle(eventType.Name, interruptionEventCounts[index])">
                <app-interruption-events-list-card
                    [canCreate]="true"
                    [Headline]="eventType.Name"
                    [Expanded]="true"
                    [CommissionId]="commissionId$ | async"
                    [EventTypeId]="eventType.Id"
                    (Count)="updateInterruptionEventsCount(index, $event)"
                ></app-interruption-events-list-card>
            </mat-tab>
        </mat-tab-group>
    </mat-expansion-panel>
    <app-blueprint style="max-width: 100%;" class="basis-full grow" [CommissionId]="commissionId$ | async" (EventMarkerClicked)="openEditEventDialog($event)" (EventListEntryClicked)="openEditEventDialog($event)"></app-blueprint>
    <app-file-explorer *ngIf="folder$ | async as folder" [SelectedFolderId]="folder.Id" [FileUploadButton]="true" [contentHeight]="'28rem'" style="padding: 0" [DisableRoutingParams]="true" class="basis-full grow mat-card"> </app-file-explorer>
</div>
